import { render, staticRenderFns } from "./ExternalParticipantChip.vue?vue&type=template&id=35ebd7a6&scoped=true"
import script from "./ExternalParticipantChip.vue?vue&type=script&lang=js"
export * from "./ExternalParticipantChip.vue?vue&type=script&lang=js"
import style0 from "./ExternalParticipantChip.vue?vue&type=style&index=0&id=35ebd7a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ebd7a6",
  null
  
)

export default component.exports